import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MenuItem } from 'primeng/api';
import { AutoFocus } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { NumberRange } from "../../../generated/generated-types";
import { NumberGeneratorService } from '../../../shared/services/number-range.service';

@Component({
  selector: 'app-input-with-number-gen',
  templateUrl: './input-with-number-gen.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MenuModule,
    InputGroupModule,
    InputTextModule,
    AutoFocus,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    ButtonModule
  ]
})
export class InputWithNumberGenComponent extends FieldType {

  constructor(
    private numRangeService: NumberGeneratorService,
    private i18n: I18nService

  ) {
    super();
  }

  loadingSig = signal<boolean>(false);

  buttonMenu: MenuItem[] = [
    {
      label: this.i18n.translate(_("common.generate-number")),
      icon: 'fa fa-dice-d20',
      command: (event) => {
        this.generateRandomNumber();
      },
      automationId: 'formly-number-gen-button',
    },
  ];

  async generateRandomNumber(): Promise<void> {
    this.loadingSig.set(true);
    try {
      let nextKey: NumberRange;
      if (this.props["numberRangeEntity"]) {
        nextKey = await this.numRangeService.getNextKey(this.props["numberRangeEntity"] as string, this.props["numberRangeVariant"] as string | undefined);
      } else {
        nextKey = await this.numRangeService.getNextKeyByIdentifier(this.props["numberRangeIdentifier"] as string);
      }
      this.formControl.setValue(nextKey.combinedKey);
      // this.options.detectChanges({});
    }
    catch (e) {
      console.error(e);
    }
    finally {
      this.loadingSig.set(false);
      // this.cdRef.detectChanges();
    }
  }
}
